import React from 'react';
import notHaveInfoImage from '../assets/image/icon/nothaveinfo.png';

const NotHaveInfo: React.FC = () => {
    return (
        <div className='NotHaveInfo'>
            <img src={notHaveInfoImage} className='notHaveInfoImage' alt="No information available" />
        </div>
    )

};

export default NotHaveInfo;
